import React from 'react';
export function JealousHowItWorks() {
  const steps = [{
    num: '1',
    title: 'Claim Your Spot',
    body: 'Click the button, fill in your info, and lock in your 67% discount before spots fill up.'
  }, {
    num: '2',
    title: 'Schedule Your Clean',
    body: 'Our team will reach out to book your cleaning at a time that works best for you.'
  }, {
    num: '3',
    title: 'Enjoy the Results',
    body: 'Sit back, relax, and watch your home transform. Your neighbors will definitely notice.'
  }];
  return <section className="w-full py-24 px-4" style={{
    background: 'linear-gradient(180deg, #EDF5FB 0%, #DDEAF6 100%)'
  }} data-id="element-323">
      <div className="max-w-7xl mx-auto" data-id="element-324">
        <div className="text-center mb-16" data-id="element-325">
          <p className="mb-3" style={{
          color: '#3B8AC4',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 700,
          fontSize: '13px',
          letterSpacing: '1px',
          textTransform: 'uppercase'
        }} data-id="element-326">
            HOW IT WORKS
          </p>
          <h2 className="mb-4" style={{
          color: '#1F2937',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 800,
          fontSize: 'clamp(28px, 4vw, 36px)',
          letterSpacing: '-0.02em',
          lineHeight: 1.2
        }} data-id="element-327">
            3 Simple Steps to a Cleaner Home
          </h2>
          <p style={{
          color: '#4F5B69',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontSize: '16px'
        }} data-id="element-328">
            Relish your free time while we handle the dirty work.
          </p>
        </div>

        {/* Professional Photos */}
        <div className="mb-16 rounded-[20px] overflow-hidden grid grid-cols-1 md:grid-cols-3 gap-0" style={{
        boxShadow: '0 8px 30px rgba(59,138,196,0.1)'
      }} data-id="element-329">
          <img src="https://cdn.magicpatterns.com/uploads/35PwYEtivsap2AEXWVfPVT/unnamed.webp" alt="Blue Cactus surface cleaning in action" className="w-full h-[240px] md:h-[280px] object-cover" data-id="element-330" />
          <img src="https://cdn.magicpatterns.com/uploads/d6bJAqzyCRo3bKkBy9cTgZ/luguensi-pressure-washing-013-scaled.webp" alt="Blue Cactus professional with tablet" className="w-full h-[240px] md:h-[280px] object-cover" data-id="element-331" />
          <img src="https://cdn.magicpatterns.com/uploads/jJVV4K84qASmM8AxmsZpXn/2024-04-25.webp" alt="Blue Cactus equipment at sunset in Phoenix neighborhood" className="w-full h-[240px] md:h-[280px] object-cover" data-id="element-332" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-333">
          {steps.map((step, i) => <div key={i} className="flex flex-col items-center text-center bg-white p-8 rounded-[16px]" style={{
          boxShadow: '0 4px 16px rgba(0,0,0,0.05)'
        }} data-id="element-334">
              <div className="w-14 h-14 rounded-full flex items-center justify-center mb-6" style={{
            backgroundColor: '#3B8AC4'
          }} data-id="element-335">
                <span style={{
              color: '#FFFFFF',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 800,
              fontSize: '24px'
            }} data-id="element-336">
                  {step.num}
                </span>
              </div>
              <h3 className="mb-3" style={{
            color: '#1F2937',
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontWeight: 800,
            fontSize: '20px',
            letterSpacing: '-0.01em'
          }} data-id="element-337">
                {step.title}
              </h3>
              <p style={{
            color: '#4F5B69',
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontSize: '15px',
            lineHeight: 1.6
          }} data-id="element-338">
                {step.body}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-339">
          <a href="tel:4805998442" className="inline-block w-full sm:w-auto text-center transition-all hover:-translate-y-1" style={{
          backgroundColor: '#F27A3A',
          color: '#FFFFFF',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 700,
          fontSize: '18px',
          padding: '18px 40px',
          borderRadius: '8px',
          boxShadow: '0 4px 14px rgba(242,122,58,0.3)'
        }} data-id="element-340">
            Book the Jealous Neighbor Package →
          </a>
        </div>
      </div>
    </section>;
}